<template>
  <div class="home">
    <h1 class="teal--text text--darken-4">Le Royaume d'Andoras</h1>
    <br/>
    En construction
  </div>
</template>

<script>
export default {
  name: 'Andoras',
  components: {
  },
}
</script>
